import React from 'react';
import { Typography as MuiTypography } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';

const useStyles = makeStyles({
  normal: {
    fontWeight: 400
  },
  bold: {
    fontWeight: 600
  },
  thin: {
    fontWeight: 300
  },
  h1: {
    fontSize: '48px'
  },
  h2: {
    fontSize: '36px'
  },
  h3: {
    fontSize: '28px'
  },
  h4: {
    fontSize: '24px'
  },
  h5: {
    fontSize: '20px'
  },
  h6: {
    fontSize: '16px'
  },
  body1: {
    fontSize: '12px'
  },
  caption: {
    fontSize: '10px'
  }
})

const Typography = props => {
  const theme = useTheme();
  const classes = useStyles();

  const {
    children,
    className,
    style = {},
    variant = 'h6',
    type = 'normal', // normal, bold, thin
    align,
    color = theme.palette.text.primary, // Hexacode
    ...rest
  } = props;

  return (
    <MuiTypography
      variant={variant}
      className={className}
      classes={{
			  h1: classes.h1,
			  h2: classes.h2,
			  h3: classes.h3,
			  h4: classes.h4,
			  h5: classes.h5,
			  h6: classes.h6,
			  body1: classes.body1,
			  caption: classes.caption
      }}
      style={{
			  fontWeight: (type === 'normal') ? 400 : (type === 'bold') ? 500 : 300,
			  color,
			  textAlign: align && align,
			  ...style
      }}
      {...rest}
    >
      { children }
    </MuiTypography>
  );
}

export default Typography;
